import {
  QtmHeader,
  QtmHeaderDivider,
  QtmHeaderMenu,
  QtmHeaderMenuLeft,
  QtmIcon,
  QtmTab,
  QtmTabs,
} from '@qtm/react';
import { useMatch, useNavigate } from 'react-router-dom';
import BrandHeader from 'shared/routes/components/layout/BrandHeader';

const Header = () => {
  const navigate = useNavigate();

  const homeLocation = !!useMatch('/');
  const dashboardLocation = !!useMatch('/dashboard');
  const usersLocation = !!useMatch('/users');
  const userLocation = !!useMatch('/users/*');

  const navigateTo = (path: string) => () => {
    navigate(path);
  };

  return (
    <QtmHeader classes="" size="medium">
      <BrandHeader />
      <div className="hidden md:flex">
        <QtmHeaderDivider />
        <QtmHeaderMenu>
          <QtmHeaderMenuLeft>
            <QtmTabs fullHeight scrollHorizontally size="medium">
              <QtmTab active={homeLocation} onClick={navigateTo('/')}>
                <QtmIcon icon="home" />
              </QtmTab>
              <QtmTab active={dashboardLocation} onClick={navigateTo('/dashboard')}>
                <QtmIcon icon="pie_chart" />
              </QtmTab>
              <QtmTab active={usersLocation || userLocation} onClick={navigateTo('/users')}>
                <QtmIcon icon="group" />
              </QtmTab>
            </QtmTabs>
          </QtmHeaderMenuLeft>
        </QtmHeaderMenu>
      </div>
    </QtmHeader>
  );
};

export default Header;
